import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "./utils/typeGuards";

export const kBpmQuantizeRoute = "/bpm-quantize";

export const kBpmQuantizeNoteValues = ["1/4", "1/8", "1/16", "none"] as const;
export type BpmQuantizeNoteValue = (typeof kBpmQuantizeNoteValues)[number];
export const kBpmQuantizeNoteValueDefault: BpmQuantizeNoteValue = "1/8";

const isBpmQuantizeNoteValue = (value: unknown): value is BpmQuantizeNoteValue =>
    typeof value === "string" && (kBpmQuantizeNoteValues as readonly string[]).includes(value);

export interface BpmQuantizeRequestBody {
    audioKey: string;
    bpm: number;
    noteValue?: BpmQuantizeNoteValue;
}

export const isBpmQuantizeRequestBody = (value: unknown): value is BpmQuantizeRequestBody =>
    isObject(value) &&
    typeof value.audioKey === "string" &&
    typeof value.bpm === "number" &&
    (value.noteValue === undefined || isBpmQuantizeNoteValue(value.noteValue));

export const kBpmQuantizeEndpoint: ApiEndpoint<BpmQuantizeRequestBody, DownloadUrlResponse> = {
    route: kBpmQuantizeRoute,
    label: "BPM Quantize",
    source: "Modal",
    category: "Audio Analysis",
    description:
        "Quantizes an audio loop to a note-value grid (1/4, 1/8, 1/16) at the given BPM by detecting onsets and time-stretching to align them. A note value of 'none' skips grid snapping and only applies the loopability cleanup.",
    isRequestBody: isBpmQuantizeRequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
